import { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../../config/firebase';

export function useConstituentItems(productCode) {
  const [constituentItems, setConstituentItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!productCode) {
      setConstituentItems([]);
      return;
    }

    async function fetchConstituentItems() {
      setLoading(true);
      setError(null);

      try {
        // Query products collection for items that have this product's code in their PntPlsssCode field
        const productsRef = collection(db, 'products');
        const q = query(productsRef, where('PntPlsssCode', '!=', null));
        const querySnapshot = await getDocs(q);

        const constituents = [];
        
        querySnapshot.forEach(doc => {
          const data = doc.data();
          const pntPlsssCode = data.PntPlsssCode;
          
          // Check if this product's code is in the PntPlsssCode field
          if (pntPlsssCode && pntPlsssCode.includes(productCode)) {
            // Only include active products
            if (data.isActive !== false) {
              constituents.push({
                id: doc.id,
                code: data.code,
                name: data.name,
                USP: data.USP,
                description: data.description,
                imageUrl: data.imageUrl,
                BrowsingGroup: data.BrowsingGroup,
                // Store which sets this item belongs to
                parentSets: pntPlsssCode.split(',').map(code => code.trim())
              });
            }
          }
        });

        // Sort constituents by name for consistent display
        constituents.sort((a, b) => (a.name || a.code).localeCompare(b.name || b.code));
        
        setConstituentItems(constituents);
      } catch (err) {
        console.error('Error fetching constituent items:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchConstituentItems();
  }, [productCode]);

  return { constituentItems, loading, error };
}
